@let options = (filteredOptions$ | async) ?? [];
@let error = error$ | async;
@let loading = (loading$ | async) ?? false;

@let currentValue = currentValue$ | async;

<mat-form-field
  class="w-full"
  subscriptSizing="dynamic">
  <mat-select
    [formControl]="control"
    [placeholder]="placeholder"
    [ngClass]="{ 'hide-select': loading }"
    (openedChange)="openChange($event)"
    [hideSingleSelectionIndicator]="true">
    <mat-select-trigger>
      @if (currentValue) {
        @if (optionTemplateRef) {
          <ng-container
            [ngTemplateOutlet]="optionTemplateRef"
            [ngTemplateOutletContext]="{ $implicit: currentValue }">
          </ng-container>
        } @else {
          {{ displayWith ? displayWith(currentValue) : currentValue }}
        }
      }
    </mat-select-trigger>

    @if (searchable) {
      <mat-form-field
        class="sticky top-0 left-0 form-sm w-full bg-white z-10 mb-2"
        (click)="$event.stopPropagation()"
        (keydown)="$event.stopPropagation()"
        subscriptSizing="dynamic">
        <input
          matInput
          type="text"
          [formControl]="searchControl"
          [placeholder]="'libs.async-select.search' | translate" />
      </mat-form-field>
    }

    @if (noneLabel !== null) {
      <mat-option [value]="null">{{ noneLabel }}</mat-option>
    }

    <cdk-virtual-scroll-viewport
      itemSize="45"
      [style.min-height.px]="options.length > 0 ? Math.min(options.length * 45, listMaxHeight) : 0"
      [style.max-height.px]="listMaxHeight">
      <!--
          HACK: mat-select-trigger doesn't work with cdk-virtual-scroll-viewport
          mat-select needs the <mat-option> element for the selected value to be present in the DOM to know
          what to display in the <mat-select-trigger>.
      -->
      @if (control.value) {
        <mat-option
          [value]="control.value"
          class="hidden"></mat-option>
      }

      <mat-option
        *cdkVirtualFor="let option of options"
        [value]="bindValue ? option[bindValue] : option"
        [disabled]="optionDisabled ? optionDisabled(option) : false">
        @if (optionTemplateRef) {
          <ng-container
            [ngTemplateOutlet]="optionTemplateRef"
            [ngTemplateOutletContext]="{ $implicit: option }">
          </ng-container>
        } @else {
          <span class="line-clamp-2"> {{ displayWith ? displayWith(option) : option }} </span>
        }
      </mat-option>
    </cdk-virtual-scroll-viewport>

    @if (options.length === 0 && !loading && !error) {
      <mat-option disabled>
        {{ "libs.async-select.no-results" | translate }}
      </mat-option>
    }
  </mat-select>

  @if (loading) {
    <div
      matSuffix
      class="flex w-full h-full justify-end items-center pr-3">
      <mat-spinner
        class="block"
        diameter="21"
        mode="indeterminate" />
    </div>
  }

  @if (error && error.length > 0 && !loading) {
    <mat-hint class="text-ruber opacity-100">
      {{ error | translate }}
      <span
        (click)="retry.emit()"
        class="underline hover:font-bold hover:cursor-pointer"
        translate>
        libs.async-select.retry
      </span>
    </mat-hint>
  }
</mat-form-field>
